// extracted by mini-css-extract-plugin
export default {"wrapper":"x2iMGwiD5JX_qcAyYPf1","nameLink":"iIX36uOa4nyWLcnvU7_g","type":"fuYBsq6rCsqOPiOj0Jzk"};